/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

(function() {
  function normalizedTargetUrl(locale) {
    var prefixByLocale = {
      en: '',
      es: 'es',
      'zh-CN': 'zh',
      zh: 'zh'
    };
    var knownPrefixes = ['en', 'es', 'zh'];
    var parts = window.location.pathname.split('/').filter(Boolean);

    if (parts.length && knownPrefixes.indexOf(parts[0].toLowerCase()) !== -1) {
      parts.shift();
    }

    var prefix = prefixByLocale[locale] || String(locale || '').toLowerCase();
    var targetParts = prefix ? [prefix].concat(parts) : parts;
    return (targetParts.length ? '/' + targetParts.join('/') : '/') + window.location.search + window.location.hash;
  }

  function redirectInvalidEnglishPrefix() {
    var path = window.location.pathname.toLowerCase();
    if (path === '/en' || path.indexOf('/en/') === 0) {
      window.location.replace(normalizedTargetUrl('en'));
    }
  }

  function bindLanguageSelector(selector) {
    if (!selector || selector.dataset.superdtfLanguageBound === 'true') return;
    selector.dataset.superdtfLanguageBound = 'true';
    selector.removeAttribute('onchange');
    selector.onchange = null;

    selector.addEventListener('change', function(event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      window.location.href = normalizedTargetUrl(selector.value);
    }, true);
  }

  function bindAllLanguageSelectors() {
    document.querySelectorAll('select[name="locale_code"]').forEach(bindLanguageSelector);
  }

  function openCartDrawerFromTrigger(trigger, event) {
    var modalId = trigger.getAttribute('data-a11y-dialog-show') || 'modal-cart';
    if (modalId !== 'modal-cart') return false;

    var modalEl = document.getElementById(modalId);
    if (!modalEl) return false;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (typeof modalEl.open === 'function') {
      modalEl.open();
    } else if (window.customElements) {
      customElements.whenDefined('modal-dialog').then(function() {
        if (typeof modalEl.open === 'function') {
          modalEl.open();
        }
      });
    }

    return true;
  }

  document.addEventListener('click', function(event) {
    var trigger = event.target && event.target.closest && event.target.closest(
      '#superdtf-cart-trigger, [data-a11y-dialog-show="modal-cart"], a[href="/cart"], a[href$="/cart"]'
    );

    if (!trigger) return;
    openCartDrawerFromTrigger(trigger, event);
  }, true);

  redirectInvalidEnglishPrefix();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAllLanguageSelectors);
  } else {
    bindAllLanguageSelectors();
  }

  new MutationObserver(bindAllLanguageSelectors).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
